/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ListingInputs */

const cs_enum_listing = /** @type {(inputs: Enum_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakázka`)
};

const en_enum_listing = /** @type {(inputs: Enum_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing`)
};

/**
* | output |
* | --- |
* | "Listing" |
*
* @param {Enum_ListingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_listing = /** @type {((inputs?: Enum_ListingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ListingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_listing(inputs)
	return cs_enum_listing(inputs)
});